/**
 * Created by wwei on 2018-11-23.
 */
import React, {Component} from 'react';
import { Form, Button, Select, Row, Col } from 'antd';
import Constant, {PRODUCT_SHOW_NAME} from '../../commons/Constants';
import { openNotification, NotificationType, getUrl } from "../../commons/CommonUtils.js";
import SvgIcon from "../../commons/SvgIcon";
import request from 'superagent';
import { Alert } from 'react-bootstrap';

const FormItem = Form.Item;
const Option = Select.Option;

class PolicyBroadcastForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            broadcasting: false,
            deviceTypes: []
        };
    }

    componentDidMount() {
        const deviceTypes = new Set(this.props.products.map(p => p.type));
        this.setState({ deviceTypes: [...deviceTypes] });// need to convert set to array
    }

    broadcast = e => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.setState({broadcasting: true});

                request.post("/api/broadcast-all")
                    .withCredentials()
                    .send({ product: values.product })
                    .end((err, res) => {
                        this.setState({broadcasting: false});
                        if (err) {
                            console.error("Failed to broadcast. ", err);
                            openNotification("Failed to broadcast the upgrade.", NotificationType.error);
                        } else {
                            openNotification("Succeed to broadcast the upgrade.", NotificationType.success);
                        }
                    });
            }
        });
    }

    render() {
        const formItemLayout = {
            labelCol: {
                xs: {span: 24},
                sm: {span: 6}
            },
            wrapperCol: {
                xs: {span: 24},
                sm: {span: 18}
            }
        };

        const { getFieldDecorator } = this.props.form;
        const { broadcasting, deviceTypes } = this.state;
        //const { products } = this.props;

        return (
            <div className="page-tenant-detail">
                <div className="page-close" onClick={() => this.props.onClose()}>
                    <span className="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
                </div>
                <div className='page-detail-title'>
                    <SvgIcon name="volume_max" />
                    <div className='page-detail-info'>
                        <b>Broadcast Upgrade</b>
                    </div>
                </div>
                <div className="form-horizontal" style={{paddingLeft: "30px", paddingRight: "30px", maxWidth: "800px"}}>
                    <Alert bsStyle="info">
                        This page is used to notify all devices of a particular type to check for software update.
                    </Alert>
                    <Form onSubmit={(e) => this.broadcast(e)} className="ant-form-horizontal">
                        <FormItem {...formItemLayout} label="Device Type">
                            {getFieldDecorator('product', {
                                rules: [{
                                    required: true, message: 'Please select a device type!'
                                }]
                            })(
                                <Select placeholder="Select a device type">
                                    {deviceTypes.map((type, index) => {
                                        return (
                                            <Option key={index} value={type}>
                                                {type}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            )}
                        </FormItem>

                        <br/>
                        <div className="ant-modal-footer" style={{padding: "10px 0"}}>
                            <Row>
                                <Col span="7" style={{"text-align": "left"}}>
                                    <Button type="primary" htmlType="submit" size="large" loading={broadcasting}>
                                        {status === broadcasting ? "Broadcasting..." : "Broadcast"}
                                    </Button>
                                    <Button size="large" htmlType="button" disabled={broadcasting}
                                            onClick={() => this.props.onClose()}>
                                        Cancel
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}

const PolicyBroadcast = Form.create()(PolicyBroadcastForm);
export default PolicyBroadcast;


// WEBPACK FOOTER //
// ./src/modules/policy/PolicyBroadcast.js